export const getSpan = (x1: number, x2: number) => 1 + Math.abs(x2 - x1);
